export const LOAD_QVCT_ANSWER_MARK = 'LOAD_QVCT_ANSWER_MARK'